import { MultiplesHelper } from "app/helpers/multiplesHelper";
import cx from "classnames";
import { differenceBy } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ROUTES } from "../../helpers/routerPathHelper";
import type { BetSlipType } from "../../types/betSlipType";
import { BetSlipStates } from "../../utils/const";
import { IconBetDrawer } from "../Icon/Icon";
import "./BetDrawerButton.scss";
import BetNotification from "./components/BetNotification/BetNotification";
type Props = {
  betSlipList: BetSlipType[];
  multiplesBetSlipList: BetSlipType[];
};

type State = {
  betSlipListLength: number;
  startAnimation: boolean;
  endAnimation: boolean;
  timerId: any;
};

class BetDrawerButton extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      betSlipListLength: props.betSlipList.length,
      startAnimation: false,
      endAnimation: false,
      timerId: null,
    };
  }

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    // if there are new items in the bet slip list
    // then start animation
    if (
      nextProps.betSlipList &&
      nextProps.betSlipList.length > prevState.betSlipListLength
    ) {
      // Reset the timeout
      clearTimeout(prevState.timerId);
      return {
        betSlipListLength: nextProps.betSlipList.length,
        startAnimation: true,
        endAnimation: false,
      };
    }

    return null;
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    // Don't refresh UI if the timerId has changed
    return nextState.timerId === this.state.timerId;
  }

  startAnimationTimer = () => {
    // start timer after 2.8 sec
    const timerId = setTimeout(() => {
      // reset animations
      this.setState({
        startAnimation: false,
        endAnimation: true,
      });
    }, 1500);
    // As we are not allowed to update state in render()
    // we use a zero timeout so it will be executed when the thread is ready
    setTimeout(() => {
      this.setState({
        timerId,
      });
    }, 0);
  };

  componentWillUnmount() {
    clearTimeout(this.state.timerId);
  }

  componentDidMount = () => {
    const { betSlipList, multiplesBetSlipList } = this.props;
    // initial check for populating multiple bets
    if (
      betSlipList &&
      betSlipList.length > 0 &&
      multiplesBetSlipList.length === 0
    ) {
      betSlipList.map(bet => MultiplesHelper.checkIfMultiplesEnabled(bet));
    }
  };

  componentDidUpdate = prevProps => {
    const { betSlipList, multiplesBetSlipList } = this.props;
    if (betSlipList.length > prevProps.betSlipList.length) {
      const diff = differenceBy(betSlipList, prevProps.betSlipList, "localId");
      if (
        betSlipList.length !== multiplesBetSlipList.length &&
        diff.length > 0
      ) {
        MultiplesHelper.checkIfMultiplesEnabled(diff[0]);
      }
    }
  };

  render() {
    this.state.startAnimation && this.startAnimationTimer();
    const betSlipCount = this.props.betSlipList.filter(
      betSlip => betSlip.state !== BetSlipStates.FINISHED
    ).length;
    // Show all finished and failed bet slips as a notifications
    const betSlipsNotifications = this.props.betSlipList.filter(
      betSlip =>
        betSlip.state === BetSlipStates.FINISHED ||
        betSlip.state === BetSlipStates.FAILED
    );
    return (
      <React.Fragment>
        <div className="bet-drawer__notification-container">
          {betSlipsNotifications.map(betSlip => (
            <BetNotification key={betSlip.localId} betSlip={betSlip} />
          ))}
        </div>
        <Link
          id="betslip_drawer"
          className={cx("bet-drawer-button", {
            "bet-drawer-button--animation-start": this.state.startAnimation,
            "bet-drawer-button--animation-end": this.state.endAnimation,
          })}
          to={ROUTES.bets}
        >
          <div className="bet-drawer-button__badge">{betSlipCount}</div>
          <IconBetDrawer className="bet-drawer-button__icon" />
        </Link>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  betSlipList: state.betSlipListModel.betSlipList,
  multiplesBetSlipList: state.multiplesBetSlipListModel.multiplesBetSlipList,
});

export default connect(mapStateToProps, null)(BetDrawerButton) as any;
